import { render, staticRenderFns } from "./WelcomeUs.vue?vue&type=template&id=1f3c1234&scoped=true&"
var script = {}
import style0 from "./WelcomeUs.vue?vue&type=style&index=0&id=1f3c1234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3c1234",
  null
  
)

export default component.exports